const MAX_SIZE = 10;

const normalizeBatchId = (batchId: unknown): number | null => {
  const id = Number(batchId);
  return Number.isFinite(id) ? id : null;
};

export const getHistory = (userId: string | undefined): number[] => {
  let history = window.localStorage.getItem(`batches_${userId}`);
  if (!history) {
    window.localStorage.setItem(`batches_${userId}`, JSON.stringify([]));
    history = JSON.stringify([]);
  }
  return JSON.parse(history)
    .map(normalizeBatchId)
    .filter((id: number | null): id is number => id !== null);
};

export const pushToHistory = (batchId: unknown, userId: string | undefined) => {
  const id = normalizeBatchId(batchId);
  if (id === null || userId == null) return;

  const history = getHistory(userId);
  const existingIndex = history.indexOf(id);

  if (existingIndex !== -1) {
    history.splice(existingIndex, 1);
  }

  if (history.length >= MAX_SIZE) {
    history.shift();
  }

  history.push(id);
  window.localStorage.setItem(`batches_${userId}`, JSON.stringify(history));
};
